<div class="modal-container" 
  [class.modal-bottomSheetMode]="bottomSheetStyle"
  [class.fade]="!bottomSheetStyle && basicModalStatus"
  [class.show]="basicModalStatus" class="{{ !!mainClass ? mainClass : ''}}" > 
  <div [class]="'modal-dialog ' + (modalSize ? 'modal-' + modalSize : '')" [class.modal-fluid]="screenSize.mobile" role="document">
    <div [class]="'modal-content ' + contentClass" [class.isloading]="loading">
      <div [class]="'modal-header ' + headerClass" [style]="!title ? 'min-height:unset':''">
        <button *ngIf="showClose" type="button" class="close pull-right" [class.persist-x]="persistXToClose" aria-label="Close" (click)="hideModal()">
          <app-icons class="close-icon" [ngClass]="{'d-none d-lg-block': !persistXToClose && !showBackArrow}" [type]="'close'" [color]=" modalName == 'prime_not_available' ? 'white' : '#418fde'"></app-icons>
          <app-icons *ngIf="!persistXToClose && !showBackArrow" [ngClass]="{'d-lg-none': !persistXToClose}" [type]="'arrow-simple'" [custom]="'left'" [color]="'#418fde'"></app-icons>
        </button>
        <button type="button" class="back-arrow" *ngIf="showBackArrow">
          <app-icons color="#418fde" type="arrow-simple" custom="left" (click)="backArrowClick.emit()"></app-icons>
        </button>
        <h4 [class]="titleClass" class="modal-title w-100 text-center" *ngIf="title">{{ title }}</h4>
        <div [class]="'icon-wrapper ' + contentIconClass" *ngIf="iconSrc">
          <span [class]="'circle ' + iconClass"><img [src]="iconSrc" class="icon" alt="Modal Icon"></span>
        </div>
      </div>
      <ng-content select="[noverflow]"></ng-content>
      <div [class]="'modal-body ' + bodyClass">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer text-center" *ngIf="options.showFooter" [ngClass]="{'block': options.customClass !== 'transparent'}">
        <app-button [color]=" modalName == 'prime_not_available' ? 'white' : '' " *ngIf="options.closeButton" [title]="options.closeButtonText" [customClasses]="options.customClass" (click)="hideModal()" aria-label="Close" mdbWavesEffect></app-button>
      </div>
    </div>
  </div>
</div>

<div class="overlay" *ngIf="overlay" (click)="hideModal()"></div>
